<template>
    <vue-dropzone v-on:vdropzone-queue-complete="reloadPage" ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
</template>

<script>
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';

    export default {
        name: "DropzoneImageUploader",
        components: {
            vueDropzone: vue2Dropzone
        },
        props: ['addImageUrl', 'maxFileSize'],
        data: function(){
            return {
                dropzoneOptions: {
                    url: this.addImageUrl,
                    thumbnailWidth: 200,
                    maxFilesize: this.maxFilesize,
                    headers: {
                        "X-CSRF-Token": this.$csrf_token
                    },
                    acceptedFiles: ".jpeg, .jpg, .png, .gif",
                    success: function(file, response){
                        //
                    },
                    error: function(file, response){
                        console.warn(response);
                    },
                    files: []
                }
            }
        },
        methods: {
            reloadPage: function(){
                window.location.reload();
            }
        }
    }
</script>

<style scoped>

</style>